import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { observer } from 'mobx-react';
import { useRootStore } from 'app/contexts/RootStoreContext';
import { useRecommendationsNewContext } from 'recommendationsNew/contexts/recommendationsNewContext';
import { getCalculateDateByRangeFromFilters, getDashboardFilter, transformKeys } from 'recommendationsNew/consts';
import { useHeatMapContext } from 'recommendationsNew/components/heatMap/contexts/heatMapContext';

const NewRecommendationDashboardContextComponent = (props) => {
  const {
    setRecommendationFilters: setFiltersContext,
    setRecommendationExternalFilters: setExternalFiltersContext,
    setIsDashboardPanel,
    setPanelCloudType,
  } = useRecommendationsNewContext();

  const { setHeatMapSortByOption, setHeatMapGroupByOptions } = useHeatMapContext();
  const { filterState, cloudType } = props;
  const { filterContext: panelFilters, sortBy, groupBy } = filterState || {};
  const { usageStore } = useRootStore();

  const location = useLocation();

  useEffect(() => {
    const paramsDashboardId = new URLSearchParams(location.search).get('id');
    const dashboardId = paramsDashboardId || location.pathname.split('/').pop();
    if (dashboardId) {
      const dashFilters =
        usageStore.customDbSubStore.customDashboardModel.getExistingDashboardByUuid(dashboardId, false) || {};
      const dashboardFilters = getDashboardFilter(dashboardId, dashFilters.filters);
      setExternalFiltersContext(dashboardFilters);

      if (panelFilters) {
        const filters = getCalculateDateByRangeFromFilters(transformKeys(panelFilters));
        setFiltersContext(filters);
      }
    }
    setHeatMapSortByOption(sortBy);
    setHeatMapGroupByOptions(groupBy);
    setIsDashboardPanel(true);
    setPanelCloudType(cloudType);
  }, [
    usageStore.customDbSubStore.customDashboardModel,
    panelFilters,
    sortBy,
    groupBy,
    cloudType,
    setFiltersContext,
    setExternalFiltersContext,
    setIsDashboardPanel,
    setPanelCloudType,
    setHeatMapGroupByOptions,
    setHeatMapSortByOption,
    location.search,
    location.pathname,
  ]);

  return null;
};

export const NewRecommendationDashboardContext = observer(NewRecommendationDashboardContextComponent);
